import type { LoyaltyCouponSeries, PageInfo } from '@@partner:types:app'
import type {
  NestedFilter,
  CommonPager,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_LOYALTY_COUPON_SERIES_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllLoyaltyCouponSeriesQuery {
  loyaltyCouponSeries: {
    edges: LoyaltyCouponSeries[]
    pageInfo: PageInfo
  }
}

export interface AllLoyaltyCouponSeriesQueryVariables {
  filter?: NestedFilter
  pager?: CommonPager
  sort?: CommonSort
}

export const GQL_QUERY_ALL_LOYALTY_COUPON_SERIES = gql`
  query($filter: NestedFilterInput, $pager: CommonPagerInput, $sort: CommonSortInput) {
    loyaltyCouponSeries: allLoyaltyCouponSeries(filter: $filter, pager: $pager, sort: $sort) {
      edges {
        ${SHORTCUT_LOYALTY_COUPON_SERIES_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllLoyaltyCouponSeries = (
  variables?: AllLoyaltyCouponSeriesQueryVariables
) =>
  useQuery<AllLoyaltyCouponSeriesQuery, AllLoyaltyCouponSeriesQueryVariables>(
    GQL_QUERY_ALL_LOYALTY_COUPON_SERIES,
    {
      variables: variables || {},
      fetchPolicy: 'cache-and-network'
    }
  )
